import React, { FunctionComponent } from 'react'
import { Message, useIsDesignLanguage, useDesignLanguagePerClass, DesignLanguage } from '@afterpaytouch/core'

import styles from './style.module.css'
import { useCheckoutState, useIsShippingOptionRequired } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { useShouldShowShippingMessage } from './hooks'

export const ShippingMessage: FunctionComponent = () => {
  const { t } = useTranslation()
  const { checkout } = useCheckoutState()
  const isShippingOptionRequired = useIsShippingOptionRequired()
  const isBronteDesignLanguage = useIsDesignLanguage(DesignLanguage.Bronte)
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const shouldShowShippingMessage = useShouldShowShippingMessage()

  const description = isShippingOptionRequired
    ? t('summary:preSelectShippingInfo')
    : t('summary:deferredShippingTips', { merchantName: checkout?.merchant?.name })
  const descriptionHeading = !isBronteDesignLanguage && t('summary:deferredShippingTipsHeading')

  if (shouldShowShippingMessage) {
    return (
      <div className={designLanguageStyles.container}>
        <Message heading={descriptionHeading} kind='Basic' iconName='Box' description={description} />
      </div>
    )
  }
  return null
}
